export enum Meal {
  Breakfast = "breakfast",
  Lunch = "lunch",
  Meal = "meal",
  Snack = "snack",
  Dinner = "dinner",
  Redinner = "redinner",
}

export function displayToKey(display: Meal) {
  const map = {
    [Meal.Breakfast]: "breakfast",
    [Meal.Lunch]: "lunch",
    [Meal.Meal]: "meal",
    [Meal.Snack]: "snack",
    [Meal.Dinner]: "dinner",
    [Meal.Redinner]: "redinner",
  };

  return map[display];
}
